// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3738":"a92ab33b","7477":"9dfaccd3","8902":"3f6624aa"}[chunkId] + ".chunk.css";
};